<app-loader *ngIf="loaderService.isLoading | async"></app-loader>
<router-outlet></router-outlet>
